import { useTranslation } from 'react-i18next';
import { Trash2 } from 'lucide-react';

import type { TableRemoveAction } from './types';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

import { stripHtml } from '@/helpers';

type TableDeleteActionProps = {
  remove: TableRemoveAction;
};

export const TableDeleteAction = (props: TableDeleteActionProps) => {
  const { remove } = props;
  const { t } = useTranslation();

  return (
    <AlertDialog>
      <Tooltip>
        <TooltipTrigger asChild>
          <AlertDialogTrigger asChild>
            <Button
              variant="destructive"
              size="icon-sm"
            >
              <Trash2 className="size-4" />
            </Button>
          </AlertDialogTrigger>
        </TooltipTrigger>
        <TooltipContent>{t('Delete')}</TooltipContent>
      </Tooltip>
      <AlertDialogContent>
        <AlertDialogHeader tone="destructive">
          <AlertDialogTitle>
            {t('Are you sure you want to delete')}
            {remove.entityName && (
              <span className="text-destructive-soft-foreground font-bold">
                {' '}
                {stripHtml(remove.entityName)}
              </span>
            )}
            {remove.id && (
              <span className="text-destructive-soft-foreground font-bold">
                {' '}
                {t('with ID')} {remove.id}
              </span>
            )}
            ?
          </AlertDialogTitle>
          <AlertDialogDescription />
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('No')}</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            onClick={remove.onConfirm}
          >
            {t('Yes')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
